export default __webpack_public_path__ + "static/media/hub.378349b5.png";